import * as angular from 'angular';
import MyNetSalesPerformanceWidgetComponent from './my-net-sales-performance-widget-component';

export default angular
  .module('my-net-sales-performance-widget', ['nvd3'])
  .component('myNetSalesPerformanceWidget', new MyNetSalesPerformanceWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-net-sales-performance/my-net-sales-performance-widget-module.ts